module.exports = __webpack_public_path__ + "static/nossos-certificados-67ac6e3b1560ac6cafe388ec3595d394.svg";